import { Stack } from "@mui/material";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { DashboardValidationType } from "../../hooks/useDashboardValidation";
import CompanyListItemContainer from "./CompanyListItemContainer";

interface Props {
  availableCompanies: ListItemData[];
  validation: DashboardValidationType;
}

const CompaniesList = ({ availableCompanies, validation }: Props) => {
  return (
    <ScrollableFlexContainer>
      <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
        {validation.selectedCompanies.map((company) => {
          return (
            <CompanyListItemContainer
              key={company.code}
              company={company}
              availableCompanies={availableCompanies}
              validation={validation}
            />
          );
        })}
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default CompaniesList;
